import SiparislerService from "../../../services/SiparislerService";

export default {
  namespaced: true,
  state: () => ({
    cancelRefundList: {
      list: [],
      count: 0
    },
    cancelRefundListLoading: false
  }),
  mutations: {
    setCancelRefundList: (state, list) => {
      state.cancelRefundList = list;
    },
    resetCancelRefundListLoading: (state, list) => {
      state.cancelRefundListLoading = list;
    },
    resetCancelRefundList: (state) => {
      state.cancelRefundList = {
        list: [],
      };
    },
  },
  actions: {
    fetchCancelRefundList: ({ commit }, data) => {
      commit("resetCancelRefundList");
      commit("resetCancelRefundListLoading", true);
      return new Promise((resolve, reject) => {
        SiparislerService.cancelAndRefundList(data)
          .then((res) => {
            commit("setCancelRefundList", res.data);
            commit("resetCancelRefundListLoading", false);
            resolve(res);
          })
          .catch((err) => {
            commit("resetCancelRefundListLoading", false);
            reject(err);
          });
      });
    },
  }
};